<template>

    <Head>
        <title head-key="title">{{ titleHead(singleCategory.title) }}</title>
        <meta head-key="apple-mobile-web-app-title" name="apple-mobile-web-app-title" :content="singleCategory.title" />
        <meta head-key="msapplication-tooltip" name="msapplication-tooltip" :content="singleCategory.title" />
    </Head>
    <Schema type="category" :category="singleCategory" />
    <v-container v-if="singleCategory" class="my-24">
        <!-- <h3 class="px-5 mt-2 mb-5 h3">{{ singleCategory.title }}</h3> -->
        <v-row>
            <!-- Filters Column -->
            <!-- <v-col cols="12" md="4">
                <v-card class="p-5">
                    <h3 class="pb-4 pb-6 mb-5 border-b h3">{{ __t('fillter_in_products') }}</h3>

                    <v-btn color="primary" class="mt-4" @click="applyFilters" :loading="isLoading">
                        {{ __t('apply_filters') }}
                    </v-btn>

                    <CountrySelectVue :autoSelectCountry="true" :userCountryCode="$page.props.userCountryCode"
                        gridType="multiline" v-model:country="form.country_id" v-model:state="form.state_id"
                        v-model:city="form.city_id" v-model:district="form.district_id"
                        class="min-w-[300px] mt-4 md:mt-0" />

                    <v-text-field v-model="form.search" :label="__t('search')" @input="onSearchInput"
                        prepend-inner-icon="mdi-magnify" />

                    <v-range-slider v-model="form.pricerange" :max="999999999999" :min="0" :step="1"
                        class="align-center" hide-details>
                        <template v-slot:prepend>
                            <v-text-field v-model="form.pricerange[0]" density="compact" style="width: 70px"
                                type="number" variant="outlined" hide-details single-line />
                        </template>
                        <template v-slot:append>
                            <v-text-field v-model="form.pricerange[1]" density="compact" style="width: 70px"
                                type="number" variant="outlined" hide-details single-line />
                        </template>
                    </v-range-slider>

                    <v-select v-model="form.category_id" :items="categories" item-text="name" item-value="id"
                        :label="__t('section')" @input="onSearchInput" clearable />

                 
                    <div v-for="attribute in attributes" :key="attribute.id">
                        <DynamicInputComponent v-model="form.attributes[attribute.id]" :attribute="attribute"
                            forFilter />
                    </div>

                    <v-btn color="primary" class="mt-4" @click="applyFilters" :loading="isLoading">
                        {{ __t('apply_filters') }}
                    </v-btn>
                </v-card>
            </v-col> -->

            <!-- Content Column -->
            <v-col cols="12" md="12">

                <v-row>
                    <nav class="breadcrumb" aria-label="Breadcrumb">
                        <ol class="flex items-center space-x-2 text-sm">
                            <li>
                                <Link :href="route('home')" class="text-gray-500 hover:text-primary">
                                    {{ __t('home') }} --
                                </Link>
                            </li>
                            <li v-if="singleCategory.parent" class="text-gray-500 hover:text-primary">
                                <Link :href="singleCategory.parent.url" class="text-gray-500 hover:text-primary">
                                    {{ singleCategory.parent.title }} 
                                </Link>
                            </li>

                            <li class="text-gray-400 px-2" aria-current="page" >
                                {{ singleCategory.title }}
                            </li>
                        </ol>
                    </nav>
                </v-row>
                <v-row>
                    <v-col cols="6" md="3" v-for="category in categories" :key="category.id">
                        <CategoryCard :section='category' />
                    </v-col>
                </v-row>

                <!-- <v-row>
                    <v-select v-model="form.sortWith" :items="sortableOptions" :label="__t('sort_by')" />
                </v-row>

                عدد النتائج : {{ totalProducts }} -->
                <v-row class="mt-3">
                    <v-col cols="6" md="3" v-for="product in visibleProducts" :key="product.id">
                        <ProductCard :product="product" />
                    </v-col>
                 <template v-if="hasMore">
                    <v-col cols="12"  v-intersect="{ handler: loadMore }" class="text-center">
                        <v-btn :loading="isLoading" color="primary">
                            Loading more...
                        </v-btn>
                    </v-col>
                </template>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { ref, watch, computed, onMounted, onServerPrefetch, nextTick } from "vue";
import debounce from "lodash/debounce";
import ProductCard from "@/Components/Cards/ProductCard.vue";
import CategoryCard from "@/Components/Cards/CategoryCard.vue";
import CountrySelectVue from "@/Components/Form/CountrySelect.vue";

import DynamicInputComponent from "@/Components/Form/DynamicInputComponent.vue";
import { fetchSingleCategory, fetchProductsPage } from "@/Composable/formUtils";
import Schema from "@/Components/Schema.vue";

// Props
const props = defineProps({
    slug: {
        type: String,
        required: true,
    },
    item: {
        type: Object,
        default: () => ({}),
        required: false,
    },
});

// State
const singleCategory = ref({ ...props.item });
const loading = ref(false);
const error = ref(null);
const hasMore = ref(false);
const lastLoadTime = ref(0);
const attributes = ref([]);
const categories = ref([]);

// Computed
const isLoading = computed(() => loading.value);
const visibleProducts = computed(() => products.value.data);
const totalProducts = computed(() => products.value.meta?.total || 0);



const DEFAULT_SORT_OPTIONS = [
    { title: "Latest", value: "latest" },
    { title: "Oldest", value: "oldest" },
    { title: "Price: Low to High", value: "price_asc" },
    { title: "Price: High to Low", value: "price_desc" },
];
const sortableOptions = ref([
    ...DEFAULT_SORT_OPTIONS
]);
const YEAR_SORT_OPTIONS = [
    { title: "Year: Low to High", value: "year_asc" },
    { title: "Year: High to Low", value: "year_desc" },
];

const KM_SORT_OPTIONS = [
    { title: "Km: Low to High", value: "km_asc" },
    { title: "Km: High to Low", value: "km_desc" },
];
// Form initialization
const initAttributes = () => {
    return singleCategory.value.attributes?.reduce((acc, attr) => {
        const value = attr.pivot.value;
        acc[attr.id] = parseValue(value);
        return acc;
    }, {}) || {};
};

const parseValue = (value) => {
    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) return parseInt(value);
        if (/^\d*\.\d+$/.test(value)) return parseFloat(value);
    }
    return value;
};

const initForm = () => ({
    category_parent: singleCategory.value.id,
    category_id: null,
    pricerange: [0, 999999999999],

    country_id: null,
    state_id: null,
    city_id: null,
    district_id: null,
    search: "",
    sortWith: 'latest',
    attributes: initAttributes()
});

const form = ref(initForm());

// Products state
const products = ref({
    data: [],
    meta: {
        current_page: 1,
        last_page: 1,
    },
});

// API calls
const debouncedFetchData = debounce(async () => {
    try {
        loading.value = true;
        error.value = null;

        const categoriesReturn = await fetchSingleCategory(props.slug, {
            withChildren: true,
            withMultiLevelChildrenProducts: false,
            withParent: true,
            filters: form.value
        });
        singleCategory.value = categoriesReturn;

        resetProducts();
        await fetchDataProduct();
    } catch (err) {
        error.value = err;
        console.error("Failed to fetch singleCategory:", err);
    } finally {
        loading.value = false;
    }
}, 500);

const getAttributes = async (id) => {
    try {
        const response = await axios.get(route('api.category.getAttributesByCategory', id));
        attributes.value = response.data.data;
        sortableOptions.value = [...DEFAULT_SORT_OPTIONS];

        const haveYear = attributes.value.find(attr => attr.slug === 'year');
        if (haveYear) {
            YEAR_SORT_OPTIONS.forEach(option => {
                if (!sortableOptions.value.find(sortOpt => sortOpt.value === option.value)) {
                    sortableOptions.value.push(option);
                }
            });
        }

        const haveKm = attributes.value.find(attr => attr.slug === 'mileage');
        if (haveKm) {
            KM_SORT_OPTIONS.forEach(option => {
                if (!sortableOptions.value.find(sortOpt => sortOpt.value === option.value)) {
                    sortableOptions.value.push(option);
                }
            });
        }


    } catch (error) {
        console.error("Failed to fetch attributes:", error);
    }
};

const addNewProducts = (newProducts) => {
    const existingIds = new Set(products.value.data.map(item => item.id));
    const uniqueNewProducts = newProducts.filter(product => !existingIds.has(product.id));
    if (uniqueNewProducts.length) {
        products.value.data = [...products.value.data, ...uniqueNewProducts];
    }
};

const fetchDataProduct = async () => {
    try {
        if (!hasMore.value || loading.value) return;

        loading.value = true;
        error.value = null;

        const result = await fetchProductsPage(
            products.value.meta.current_page,
            9,
            form.value
        );

        addNewProducts(result.data);
        products.value.meta = result.meta;
        hasMore.value = products.value.meta.current_page < products.value.meta.last_page;

    } catch (err) {
        error.value = err;
        console.error("Failed to fetch products:", err);
    } finally {
        loading.value = false;
    }
};

// Event handlers
const debounceSearch = debounce((value) => {
    form.value.search = value;
    applyFilters();
}, 300);

const onSearchInput = (value) => {
    debounceSearch(value);
};

const loadMore = async () => {
    if (loading.value || !hasMore.value) return;

    if (Date.now() - lastLoadTime.value < 1000) return;
    lastLoadTime.value = Date.now();

    products.value.meta.current_page += 1;
    await fetchDataProduct();
};

const resetProducts = () => {
    products.value.data = [];
    products.value.meta.current_page = 1;
    hasMore.value = true;
};

const applyFilters = () => {
    resetProducts();
    fetchDataProduct();
};

const fetchCategories = () => {
    categories.value = singleCategory.value.children;
};

// Watchers
watch(() => form.value.sortWith, () => {
    resetProducts();
    fetchDataProduct();
}, { deep: false });

watch(() => form.value.category_id, (newVal) => {
    if (newVal) {
        getAttributes(newVal);
    } else {
        form.value.attributes = {};
        getAttributes(singleCategory.value.id);
    }
}, { deep: false });

// Lifecycle hooks
onServerPrefetch(async () => {
    await debouncedFetchData();
});

onMounted(() => {
    if (!props.slug) {
        window.location.href = "/404";
        return;
    }

    if (products.value.data.length === 0) {
        resetProducts();
        fetchDataProduct();
    }

    fetchCategories();
    nextTick(() => {
        getAttributes(singleCategory.value.id);
    });
});
</script>
